import {rpcCall} from '../../util/rpc/rpcCalls'
import {BASE_PATH} from 'constants'
import messageResource from '../../messageResource'
import {Exceptions as ICalendarExceptions} from '../../common/icalendar/constants'
import {Exception as Exceptions} from './constants'

export function getPageData(year) {
    return rpcCall("WorkScheduleService.getWorkScheduleData", [year], _handleError)
}

export function addCorporateDay(date, isWorking, title) {
    return rpcCall("WorkScheduleService.addCorporateDay", [date, isWorking, title])
}

export function deleteCorporateDay(date) {
    return rpcCall("WorkScheduleService.deleteCorporateDay", [date])
}

export function addHolidays(year, holidays) {
    return rpcCall("WorkScheduleService.addHolidays", [year, holidays])
}

export function deleteHolidays(year) {
    return rpcCall("WorkScheduleService.deleteHolidays", [year])
}

export function getCountries() {
    return rpcCall("WorkScheduleService.getCountries", [], _handleError)
}

export function getHolidays(countryId, year) {
    return rpcCall("WorkScheduleService.getHolidays", [countryId, year], _handleError)
}

export function getCorporateScheduleICalendar(year) {
    return rpcCall("WorkScheduleService.getCorporateScheduleICalendar", [year], _handleError)
}

function _handleError(error) {
    if (error.getException() === ICalendarExceptions.NO_RIGHTS_FOR_REMOTE_CALL_EXCEPTION) {
        alert(messageResource.getMessage('error.js.json_rpc.no_rights'))
        window.location.href = BASE_PATH
    }

    if (error.getException() === Exceptions.RETRIEVE_COUNTRIES_EXCEPTION) {
        //no alert, select country section will be hidden
        error.handle()
    }

    if (error.getException() === Exceptions.RETRIEVE_HOLIDAYS_EXCEPTION) {
        alert('Error when retrieving holidays, load holidays from file or try later')
        error.handle()
    }

    if (error.getException() === ICalendarExceptions.EMPTY_COMPONENTS_EXCEPTION) {
        alert(messageResource.getMessage('work_schedule.export.ical.no_corporate_days'))
        error.handle()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/apiCalls.js